<template>
  <!-- Content Left Rail -->
  <v-container class="pa-0 main-left-content">
    <v-list
      flat
      class="customer-list px-3 py-1"
      v-for="customer in customerLookup"
      :key="'customer-list-' + customer.id"
    >
      <v-list-item class="pa-0 pl-2" @click="clickCustomer(customer.id)">{{
        customer.name
      }}</v-list-item>
    </v-list>
    <div v-if="customerListEmpty" class="no-results-row mt-12">
      <v-card flat>
        <v-container class="text-center"
          ><v-icon large>mdi-account-group</v-icon></v-container
        >
        <v-card-title class="text-center"
          ><div class="full-width">No Customers</div></v-card-title
        >
        <v-card-text class="text-center">
          Add your first customer to get started.
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "CustomersLeftRail",
  props: {
    msg: String
  },
  data: function() {
    return {};
  },
  created() {
    this.$store.dispatch("entities/accounts/pingAccountLevelDisplay");
    this.$store.dispatch("entities/customerLookups/hydrate");
  },
  computed: {
    userId() {
      return this.$store.getters["entities/settings/query"]().first().userId;
    },
    user() {
      return this.$store.getters["entities/users/find"](this.userId);
    },
    customerLookup() {
      return this.$store.getters["entities/customerLookups/query"]()
        .orderBy("date", "desc")
        .get()
        .slice(0, 100);
    },
    customerListEmpty() {
      return this.customerLookup.length == 0;
    }
  },
  methods: {
    async clickCustomer(id) {
      if (["customers"].includes(this.$route.name)) {
        await this.$store.dispatch("entities/customers/clickCustomer", {
          customerId: id
        });
        //this.scrollToBottomOfHistory();
      } else if (this.$route.name == "calendar") {
        this.$parent.$parent.dialogSetCustomerId(id);
      }
      this.switchToCustomerHistory();
      this.$root.$children[0].navMenuOpen = false;
    },
    switchToCustomerHistory() {
      this.$store.dispatch("entities/settings/update", {
        where: 1,
        data: {
          showCustomerDetail: true
        }
      });
    },
  }
};
</script>

<style scoped lang="stylus">
div.customer-list:hover {
  background-color: #efefef;
  cursor:pointer;
}
div.v-list-item--link:before {
  background-color: white;
}
</style>
